import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExporting from 'highcharts/modules/exporting';

const OfflinePieChart = (props) => {

    const redNum = (props?.data[0]/props?.totalUsers)*100;
    const yellowOneNum = (props?.data[1]/props?.totalUsers)*100;
    const yellowTwoNum = (props?.data[2]/props?.totalUsers)*100;
    const greenNum = (props?.data[3]/props?.totalUsers)*100;

    const options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: `${props?.title ? props.title : 'Team HWI - antal per resultatkategori (procent)'}`,
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                }
            }
        },
        series: [{
            name: 'Svarat percentage',
            colorByPoint: true,
            data: [{
                name: '12-24',
                y: redNum,
                color: '#B23722',
            }, {
                name: '25-41',
                y: yellowOneNum,
                color: '#c35f1c',
            },  {
                name: '42-59',
                y: yellowTwoNum,
                color: '#E9B90F',
            }, {
                name: '60-72',
                y: greenNum,
                color: '#778441',
            }, ]
        }]
    }

    if (typeof Highcharts === 'object') {
        HighchartsExporting(Highcharts)
    }

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )

}

export default OfflinePieChart;